module.exports = __webpack_public_path__ + "static/teck_5-43f1dd3d34dc3d64179c5f99570e62d6.jpg";